module.exports = __webpack_public_path__ + "static/media/favicon.ab119964.ico";